import React, { FC, useEffect } from 'react'
import { createBrowserRouter, useNavigate } from 'react-router-dom'

import { SBXLayout, sbxRoutes } from './pages/SBX'
import { GHLayout, globalHubCommonRoute, globalHubPreviewRoute, globalHubProjectRoute } from './pages/GlobalHub'
import { adminRoute } from './pages/Admin/routes'

import { ClientErrorPage } from 'pages/Errors/ClientErrorPage'

import { LoginCallback } from './modulesCommon/LoginCallback/containers'

import App from './App'
import { OktaRouteProvider } from 'providers/OktaRouteProvider'
import { useCurrentUser } from 'modules/User/useCurrentUser'
import { CanRoute, Roles } from 'shared/abilities'
import { Errors } from 'pages/Errors'
import { ENABLED_FEATURES } from 'shared/utils/featureFlags'
import NotificationsPage from './pages/NotificationsPage'

const LandingPagesMap = new Map<string, Roles[]>([
  ['/globalhub', [
    Roles.GlobalManager,
    Roles.GlobalProjectOwner,
    Roles.Admin
  ]],
  ['/feed', [
    Roles.Viewer,
    Roles.Author,
    Roles.LocalProjectOwner,
    Roles.ZoneManager,
    Roles.SpaceMember,
    Roles.SpacePO,
    Roles.SpaceManager
  ]]
])
const RedirectToRolesHomePage: FC = () => {
  const navigate = useNavigate()
  const { user } = useCurrentUser()

  useEffect(() => {
    if (user) {
      // if (user.label_id) setZone(user.label_id, user.country_code)
      if (ENABLED_FEATURES.GLOBALHUB) {
        for (const [route, roles] of LandingPagesMap.entries()) {
          if (roles.includes(user.role?.role_id as Roles)) {
            navigate(route)
          }
        }
      } else {
        navigate('/feed')
      }
    }
  }, [navigate, user])
  return null
}

export const router = createBrowserRouter([
  {
    path: '/',
    element: <OktaRouteProvider />,
    children: [
      {
        path: '/',
        element: <App />,
        errorElement: <ClientErrorPage />, //TODO: Create Generic Error Page
        children: [
          {
            path: '/',
            element: <RedirectToRolesHomePage />
          },
          ENABLED_FEATURES.GLOBALHUB ? {
            path: '/globalhub',
            element: <CanRoute I="access" a="GlobalHub" />,
            children: [
              {
                element: <GHLayout />,
                children: [
                  globalHubProjectRoute,
                  globalHubCommonRoute,
                  globalHubPreviewRoute
                ]
              }
            ]
          } : {},
          ...sbxRoutes,
          {
            path: '/notifications/settings',
            element: <SBXLayout />,
            children: [
              {
                index: true,
                element: <NotificationsPage />
              }
            ]
          },
          {
            path: '/admin',
            element: <CanRoute I="access" a="AdminPanel" />,
            children: [{
              element: <SBXLayout />,
              children: [adminRoute]
            }]
          }
        ]
      }, {
        path: '/auth/callback',
        element: <LoginCallback />
      },
      {
        path: '*',
        element: <Errors.NotFound />
      }
    ]
  }
])
